// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"c08ae670","229":"38c1487f","360":"5dbb1c7d","498":"c20bfc5f","513":"67f81fec","545":"f69f452b","642":"0b0ad314","644":"765448a1","726":"c9d6bf33","886":"956c5f3e","997":"e2479130"}[chunkId] + ".chunk.js";
};